import React, { useState, useEffect } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from "@mui/icons-material/Close";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import IconButton from "@mui/material/IconButton";
import GroupIcon from "@mui/icons-material/Group";
import Tooltip from "@material-ui/core/Tooltip";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import TuneIcon from "@mui/icons-material/Tune";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TurnedInIcon from "@mui/icons-material/TurnedIn";
import CloudIcon from "@mui/icons-material/Cloud";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SettingsIcon from "@mui/icons-material/Settings";
import HubIcon from '@mui/icons-material/Hub';

import { matchPath, useLocation, Link } from "react-router-dom";

import "./styles.css";
import { ReactComponent as WhiteLogoSVG } from "../../assets/logo/M_WHITE_LOGO_FULL.svg";
import { ReactComponent as WhiteLogoSmallSVG } from "../../assets/logo/M_WHITE_LOGO_SQUARE.svg";

const sidebarItems = [
  { title: "Home", path: "/", icon: <HomeIcon /> },
  { title: "Comunidades", path: "/communities", icon: <HubIcon /> },
  { title: "Produtos", path: "/products", icon: <ShoppingCartIcon /> },
  {
    title: "Importações",
    path: "/imports",
    icon: <CloudIcon />,
  },
];
const sidebarInitialState = getInitialSidebarState();
const ref = React.createRef();

export default function Navbar() {
  const [sidebar, setSidebar] = useState(getInitialSidebarState());
  const [currentPage, setCurrentPage] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setCurrentPageOnSidebar();
  }, [sidebar, currentPage]);

  //Gets the current page location and indicate on sidebar
  const setCurrentPageOnSidebar = () => {
    const currentLocation = pathname.split("/")[1];
    sidebarItems.forEach((sidebarItem, index) => {
      if (`/${currentLocation}` === sidebarItem.path) {
        setCurrentPage(sidebarItem.path);
      }
    });
  };
  //Toggle the sidebar state
  const toggleSidebar = () => {
    localStorage.setItem("SIDEBAR_STATE", !sidebar);
    setSidebar(!sidebar);
  };

  return (
    <>
      <nav className={sidebar ? "nav-menu nav-open" : "nav-menu"}>
        <IconButton className="toggle-navbar-button" onClick={toggleSidebar}>
          <ArrowForwardIosIcon className={!sidebar ? "arrow-right" : null} />
        </IconButton>

        <WhiteLogoSmallSVG className="nav-logo-mobile" />

        {sidebar ? (
          <WhiteLogoSVG className="nav-logo" />
        ) : (
          <WhiteLogoSmallSVG className="nav-logo nav-logo-small" />
        )}

        <List className="nav-items mt-5">
          {sidebarItems.map((item, index) => (
            <div key={index + 1} className="px-1">
              <ListItem
                disablePadding
                className={
                  item.path === currentPage
                    ? "nav-item-selected nav-item"
                    : "nav-item"
                }
              >
                {sidebar ? (
                  <SidebarLink
                    pathRedirect={item.path}
                    icon={item.icon}
                    displayText={sidebar}
                    text={item.title}
                  />
                ) : (
                  <Tooltip title={item.title} placement="right" arrow>
                    <div className="nav-item-container">
                      <SidebarLink
                        pathRedirect={item.path}
                        icon={item.icon}
                        displayText={sidebar}
                        text={item.title}
                      />
                    </div>
                  </Tooltip>
                )}
              </ListItem>
              {sidebarItems.length - 1 !== index ? <Divider /> : null}
            </div>
          ))}
        </List>
      </nav>
    </>
  );
}

const SidebarLink = (props) => (
  <Link to={props.pathRedirect}>
    <ListItemButton className="nav-item-button">
      <ListItemIcon className="nav-item-icon">{props.icon}</ListItemIcon>
      {props.displayText ? (
        <ListItemText primary={props.text} className="list-text" />
      ) : null}
    </ListItemButton>
  </Link>
);

function getInitialSidebarState() {
  //If the screen width is less than 1550px, the sidebar must start as closed
  const pageWidth = window.innerWidth;
  if (pageWidth < 1550) return false;

  //If the sidebar state is stored on localstorage, returns the state stored
  const storedState = localStorage.getItem("SIDEBAR_STATE") === "true";
  if (storedState !== null) return storedState;

  return false;
}
